import React, { useEffect } from "react";
import { useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useTranslation } from "@/translations/TranslationContext";
import ReliableAccounting from "@/assets/bookkeepingservices.png";
import MonthlyBookkeeping from "@/assets/about-empower1.png";
import AboutImage from "@/assets/about-empower3.png"
import Iconbookkeepingservices from "@/assets/icon_bookkeepingservices.png";
import Icontaxplanning from "@/assets/icon_taxplanning.png";
import Iconfinancialanalysis from "@/assets/icon_financialanalysis.png";
import whatcando from "@/assets/whatcando.jpg";
import "./ServicesWeOffer.css";

function ServicesWeOffer() {
  const { t } = useTranslation();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  const highlightStyle = {
    color: "#007bff",
    fontWeight: "bold"
  };

  // Handle navigation without using Link directly
  const navigateTo = (path: string) => {
    window.location.href = path;
  };

  return (
    <>
      <div className="services_we_offer" ref={ref}>
        <div className="container">
          <div className="servofertext">
            <span className="chips">{t.servicesWeOffer.title}</span>
            <h2>
              <span style={highlightStyle}>{t.servicesWeOffer.viewAll}</span>
            </h2>
            <p>
              {t.servicesWeOffer.subtitle}
            </p>
          </div>

          <ul className="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="bookkeepingservices-tab"
                data-bs-toggle="pill"
                data-bs-target="#bookkeepingservices"
                type="button"
                role="tab"
                aria-controls="bookkeepingservices"
                aria-selected="true"
              >
                <span>{t.servicesWeOffer.services.bookkeeping.title}</span>
                <img
                  src={Iconbookkeepingservices}
                  alt="Iconbookkeepingservices"
                />
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="taxplanning-tab"
                data-bs-toggle="pill"
                data-bs-target="#taxplanning"
                type="button"
                role="tab"
                aria-controls="taxplanning"
                aria-selected="false"
              >
                <span>{t.footer.services.taxPlanning}</span>
                <img
                  src={Icontaxplanning}
                  alt="Icontaxplanning"
                />
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="financialanalysis-tab"
                data-bs-toggle="pill"
                data-bs-target="#financialanalysis"
                type="button"
                role="tab"
                aria-controls="financialanalysis"
                aria-selected="false"
              >
                <span>{t.footer.services.financialAnalysis}</span>
                <img
                  src={Iconfinancialanalysis}
                  alt="Iconfinancialanalysis"
                />
              </button>
                </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="strategicadvising-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#strategicadvising"
                      type="button"
                      role="tab"
                      aria-controls="strategicadvising"
                      aria-selected="false"
                    >
                      <span>{t.footer.services.strategicSupport}</span>
                      <img
                        src={Iconbookkeepingservices} /* You may need to create/import a new icon */
                        alt="Accompagnement stratégique"
                      />
                    </button>
                  </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="bookkeepingservices"
              role="tabpanel"
              aria-labelledby="bookkeepingservices-tab"
            >
              <div className="bluebox">
                <img 
                  className="blueboximg" 
                  src={ReliableAccounting} 
                  alt="ReliableAccounting"
                />

                <div className="boxcontent">
                  <img 
                    src={Iconbookkeepingservices} 
                    alt="Bookkeeping Services"
                  />
                  <h3>
                    {t.servicesWeOffer.services.bookkeeping.title}
                  </h3>
                  <p>
                    {t.servicesWeOffer.services.bookkeeping.description}
                  </p>
                  <button 
                    className="btn btn-secondary" 
                    type="button"
                    onClick={() => navigateTo('/monthly-bookkeeping')}
                  >
                    {t.servicesWeOffer.viewAll}
                  </button>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="taxplanning"
              role="tabpanel"
              aria-labelledby="taxplanning-tab"
            >
              <div className="bluebox">
                <img 
                  className="blueboximg"
                  src={MonthlyBookkeeping} 
                  alt="MonthlyBookkeeping"
                />

                <div className="boxcontent">
                  <img 
                    src={Icontaxplanning} 
                    alt="Tax Planning"
                  />
                  <h3>{t.footer.services.taxPlanning}</h3>
                  <p>
                    {t.servicesWeOffer.services.taxPreparation.description}
                  </p>
                  <button 
                    className="btn btn-secondary" 
                    type="button"
                    onClick={() => navigateTo('/tax-preparation')}
                  >
                    {t.servicesWeOffer.viewAll}
                  </button>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="financialanalysis"
              role="tabpanel"
              aria-labelledby="financialanalysis-tab"
            >
              <div className="bluebox">
                <img 
                  className="blueboximg"
                  src={AboutImage} 
                  alt="AboutImage"
                />

                <div className="boxcontent">
                  <img 
                    src={Iconfinancialanalysis} 
                    alt="Financial Analysis"
                  />
                  <h3>{t.footer.services.financialAnalysis}</h3>
                  <p>
                    {t.servicesWeOffer.services.financialPlanning.description}
                  </p>
                  <button 
                    className="btn btn-secondary" 
                    type="button"
                    onClick={() => navigateTo('/financial-planning')}
                  >
                    {t.servicesWeOffer.viewAll}
                  </button>
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="strategicadvising"
              role="tabpanel"
              aria-labelledby="strategicadvising-tab"
            >
              <div className="bluebox">
                <img 
                  className="blueboximg"
                  src={whatcando} /* You might want to use a different image */
                  alt="StrategicAdvising"
                />

                <div className="boxcontent">
                  <img 
                    src={Iconbookkeepingservices} /* Replace with appropriate icon */
                    alt="Accompagnement stratégique"
                  />
                  <h3>{t.footer.services.strategicSupport}</h3>
                  <p>
                    {t.servicesWeOffer.services.businessConsulting.description}
                  </p>
                  <button 
                    className="btn btn-secondary" 
                    type="button"
                    onClick={() => navigateTo('/business-consulting')}
                  >
                    {t.servicesWeOffer.viewAll}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServicesWeOffer;
